import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles/";

import store from "store";

import AppHeader from "./AppHeader";
import Main from "./Main";
import AppFooter from "./AppFooter";
import theme from "./theme";

const history = createBrowserHistory();

const App = () => {
  useEffect(() => {
    const unlisten = history.listen(location => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    });

    return () => unlisten();
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <React.Fragment>
        <CssBaseline />
        <div>
          <AppHeader />

          <Main />

          <AppFooter />
        </div>
      </React.Fragment>
    </MuiThemeProvider>
  );
};

const JazaApp = () => {
  return (
    <Provider store={store}>
      <BrowserRouter history={history}>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

export default JazaApp;
